export default "__VITE_ASSET__0MtASKLM__"